import { Smartphone } from 'lucide-react';
import type { AdminPushDevice } from 'app/javascript/types/admin';

const PLATFORM_LABELS: Record<string, string> = { apple: 'iOS', google: 'Android' };

export default function UserDevices({ devices }: { devices: AdminPushDevice[] }) {
  if (devices.length === 0) return <span className="text-muted-foreground">—</span>;

  return (
    <div className="flex flex-wrap gap-1.5" aria-label="Dispositivos cadastrados">
      {devices.map((device, index) => (
        <span
          key={`${device.platform}-${device.name ?? 'device'}-${index}`}
          className="inline-flex items-center gap-1 rounded-md bg-secondary/70 px-1.5 py-0.5 text-[11px] text-muted-foreground"
        >
          <Smartphone className="size-3" />
          {device.name || 'Dispositivo'} · {PLATFORM_LABELS[device.platform] ?? device.platform}
        </span>
      ))}
    </div>
  );
}
